export const ReportStudioKey = {
  DATE: 'createdAt',
  FILE_NAME: 'file_name',
  DOCUMENT_TYPE: 'doc_ext',
  ACTIONS: 'actions'
};
export const ReportStudioLabel = {
  DATE: 'Date',
  FILE_NAME: 'File Name',
  DOCUMENT_TYPE: 'Document Type',
  ACTIONS: 'Action'
};
